import React, { useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_API_URL || "";
const tok = () => localStorage.getItem("token") || "";
const hdr = () => ({ "Content-Type": "application/json", Authorization: "Bearer " + tok() });

export default function Broadcast() {
  const [message, setMessage]   = useState("");
  const [active,  setActive]    = useState(null);
  const [saving,  setSaving]    = useState(false);
  const [clearing,setClearing]  = useState(false);
  const [saved,   setSaved]     = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await fetch(API + "/api/broadcast/active", { headers: hdr() });
      if (r.ok) { const d = await r.json(); setActive(d.message || null); }
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  const publish = async () => {
    if (!message.trim()) return;
    setSaving(true);
    try {
      await fetch(API + "/api/broadcast", { method: "POST", headers: hdr(), body: JSON.stringify({ message: message.trim() }) });
      setActive(message.trim());
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch {}
    setSaving(false);
  };

  const clear = async () => {
    setClearing(true);
    try {
      await fetch(API + "/api/broadcast", { method: "DELETE", headers: hdr() });
      setActive(null);
      setMessage("");
    } catch {}
    setClearing(false);
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto" }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: "flex", alignItems: "center", gap: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 13, background: "linear-gradient(135deg,#b45309,#7c3aed)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0, boxShadow: "0 0 24px rgba(180,83,9,.35)" }}>📢</div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 900, color: "#1c1917", letterSpacing: "-.4px" }}>Broadcast</div>
          <div style={{ fontSize: 12, color: "#a8a29e", marginTop: 2 }}>Send a scrolling notice to all users on their dashboard</div>
        </div>
      </div>

      {/* Current broadcast status */}
      <div className="adm-card adm-card-pad" style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#78716c", textTransform: "uppercase", letterSpacing: 1, marginBottom: 12 }}>Current Broadcast</div>
        {active ? (
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <div style={{ flex: 1, background: "rgba(180,83,9,0.06)", border: "1px solid rgba(180,83,9,0.2)", borderRadius: 10, padding: "12px 16px", fontSize: 13, color: "#292524", fontWeight: 500, minWidth: 200 }}>
              <span style={{ marginRight: 8 }}>📡</span>{active}
            </div>
            <button onClick={clear} disabled={clearing} className="adm-btn adm-btn-danger" style={{ flexShrink: 0 }}>
              {clearing ? "Clearing…" : "✕ Clear Broadcast"}
            </button>
          </div>
        ) : (
          <div style={{ color: "#d6d3d1", fontSize: 13, display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#d6d3d1", display: "inline-block" }} />
            No active broadcast — users see nothing
          </div>
        )}
      </div>

      {/* Compose */}
      <div className="adm-card adm-card-pad">
        <div style={{ fontSize: 13, fontWeight: 800, color: "#292524", marginBottom: 16 }}>Compose New Broadcast</div>
        <div className="adm-form-row">
          <label className="adm-label">Message</label>
          <textarea
            className="adm-input"
            rows={3}
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="e.g. 🚨 System maintenance scheduled tonight 11 PM – 1 AM. Service may be briefly interrupted."
            style={{ resize: "vertical", lineHeight: 1.7, fontFamily: "inherit" }}
          />
          <div style={{ fontSize: 11, color: "#d6d3d1", marginTop: 5 }}>{message.length} characters — this will scroll across the top of every user's dashboard</div>
        </div>

        {/* Preview */}
        {message.trim() && (
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#d6d3d1", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Preview</div>
            <div style={{ background: "linear-gradient(90deg,rgba(180,83,9,0.1),rgba(124,58,237,0.1))", border: "1px solid rgba(180,83,9,0.25)", borderRadius: 10, padding: "10px 16px", overflow: "hidden", position: "relative" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 11, fontWeight: 800, color: "#b45309", letterSpacing: 1.5, textTransform: "uppercase", flexShrink: 0, borderRight: "1px solid rgba(180,83,9,0.3)", paddingRight: 12, whiteSpace: "nowrap" }}>📡 Notice</span>
                <div style={{ overflow: "hidden", flex: 1 }}>
                  <div style={{ display: "inline-block", animation: "ticker-scroll 12s linear infinite", whiteSpace: "nowrap", fontSize: 13, color: "#292524", fontWeight: 500 }}>
                    {message}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{message}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={publish} disabled={saving || !message.trim()} className="adm-btn adm-btn-primary" style={{ opacity: saving || !message.trim() ? .5 : 1 }}>
            {saved ? "✓ Published!" : saving ? "Publishing…" : "📢 Publish Broadcast"}
          </button>
          {message && <button onClick={() => setMessage("")} className="adm-btn">Clear</button>}
        </div>
      </div>
    </div>
  );
}
